import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Medium, LessThanMedium } from '@justgiving/responsive';
import { withErrorBoundary } from '@justgiving/error-boundary';

import ErrorPage from '../ErrorPage/ErrorPage';
import checkLogin from '../../actions/setters/checkLogin';
import { Navigation } from '../Navigation';
import { redirectToLogin } from '../../utils';
import { setKoalaAnalyticsConsts } from '../../utils/koala-analytics';
import componentDidCatch from '../../utils/componentDidCatch';
import Routes from '../../Routes';
import GlobalAlert from '../GlobalAlert/GlobalAlert';

export const App = () => {
  const { location } = useHistory();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(state => state.app.loginStatus.isLoggedIn);
  useEffect(() => {
    setKoalaAnalyticsConsts();
    dispatch(checkLogin());
  }, []); // eslint-disable-line

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (isLoggedIn === false) redirectToLogin();
  }, [isLoggedIn]);

  if (!isLoggedIn) return null;

  return (
    <div className="jg-eua-app">
      <GlobalAlert />
      <Medium>
        <div className="container jg-space-mvlg">
          <div className="row">
            <div className="col-md-3">
              <Navigation />
            </div>
            <div className="col-md-9">
              <Routes />
            </div>
          </div>
        </div>
      </Medium>
      <LessThanMedium>
        <Routes />
      </LessThanMedium>
    </div>
  );
};

export default withErrorBoundary(App, <ErrorPage />, componentDidCatch);
